import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';

const MODERN_LIST_ALLOWED_GROUP = 'CINT-Statistics-User-Read';

export const GroupAccessGuard: CanActivateFn = () => {
  const msalService = inject(MsalService);
  const router = inject(Router);

  const account = msalService.instance.getActiveAccount() ?? msalService.instance.getAllAccounts()[0];

  if (!account) {
    return router.createUrlTree(['/Auth']);
  }

  const groupsClaim = account.idTokenClaims?.['groups'];
  const userGroups = Array.isArray(groupsClaim)
    ? groupsClaim.filter((value): value is string => typeof value === 'string')
    : [];

  if (userGroups.includes(MODERN_LIST_ALLOWED_GROUP)) {
    return true;
  }

  return router.createUrlTree(['/Auth'], {
    queryParams: { accessDenied: '1' },
  });
};